module.exports = __webpack_public_path__ + "stickers.png?f999d62509e8160724511e727943f89c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stickers.png
// module id = 132
// module chunks = 0